import { Dispatch } from "../../config/controller";
import { Medico } from "../../config/data.types";
import { Model,StateProps } from "../../config/model";

export type { Medico } from "../../config/data.types";

export interface MedicoState extends StateProps<Medico> {
 
}

export interface MedicoActions extends Dispatch<Medico> {

}

const model = new Model<Medico,MedicoState>("medico");

export const initialValueMedico:Medico = {
    ...model.getInitialValue(),
    type:"medico",
    nome:"",
    especialidade:""
}

export const initialValueMedicoState:MedicoState = {
    ...model.getInititalValueState(),
    row:initialValueMedico,   
}


